var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f29a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 6c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30 26c0 2.2092-1.7908 4-4 4s-4-1.7908-4-4 1.7908-4 4-4 4 1.7908 4 4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18 9c0-1.6569 1.3431-3 3-3 1.6568 0 3 1.3431 3 3v9h4v-9c0-3.866-3.134-7-7-7s-7 3.134-7 7v14c0 1.6568-1.3431 3-3 3-1.6569 0-3-1.3432-3-3v-9h-4v9c0 3.866 3.134 7 7 7s7-3.134 7-7v-14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoute);
export default __webpack_public_path__ + "static/media/icon_route.3d5b950cf227190570d1b76ce8fc71a0.svg";
export { ForwardRef as ReactComponent };